<div class="detail-container">
  @if (propertyResource.isLoading()) {
    <property-skeleton />
  } @else if (propertyResource.error()) {
    <error-card/>
  } @else {
    @if (propertyResource.value(); as roomContentProperty) {
      <div class="d-flex gap-4">
        <div>
          <section-header>{{ roomContentHeader() }}</section-header>
            <div class="d-flex flex-wrap gap-4">
              <document-card [style.view-transition-name]="'card-image'" class="document-card">
                @if (roomContentProperty.hasImageError()) {
                  <span class="text-center" card-content>{{ roomContentProperty.name() }}</span>
                } @else {
                  <img card-content class="h-100" (error)="roomContentProperty.handleImageError()" [src]="roomContentProperty.thumbnailUrl()" alt="image" />
                }
                <span card-footer class="font-5">{{roomContentProperty.name()}}</span>
              </document-card>
            </div>
        </div>
      </div>

      <div class="mt-4">
        <section-header>Room Content Properties</section-header>

        <div masonry class="masonry-columns">
          @for (category of roomContentProperty.categories(); track $index) {
            <property-card>
              <div title class="d-flex align-items-center">
                  @if(!category.hasImageError()) {
                      <img height="50" src="{{category.thumbnailUrl()}}" (error)="category.handleImageError()"/>
                  }
                <span>{{ category.name() }}</span>
              </div>

              <div content class="d-flex flex-column gap-3 primary-text">
                <property-item-header />

                @for (property of category.properties(); track $index) {
                  <property-item-row [name]="property.name()" [value]="property.values()"></property-item-row>
                }
              </div>
            </property-card>
          } @empty {
            <empty-property-card />
          }
        </div>
      </div>

      @if(roomContentProperty.documents().length; as length) {
        <div class="mt-4">
          <carousel [enableHover]="true" [dataSource]="roomContentProperty.documents()" class="carousel carousel-bottom-center z-3">
            <span carousel-label>Room Content Documents ({{ length }})</span>
          </carousel>
        </div>
      }
    }
  }
</div>